import {
  Flex,
  UseCheckboxProps,
  Input,
  useCheckbox,
} from '@wegroup/design-system';
import React from 'react';
import Checkbox from '../../../../design-system/src/content/components/Checkbox';
import IllustrationButton from './IllustrationButton';

interface Props {
  Illustration: React.ReactElement;
  dataTestId?: string;
  useCheckboxProps: UseCheckboxProps;
}

const IllustrationCheckboxButton: React.FC<React.PropsWithChildren<Props>> = ({
  Illustration,
  children,
  dataTestId = 'RISK-ANALYSIS_ILLUSTRATION-CHECKBOX-BUTTON',
  useCheckboxProps,
  ...otherProps
}) => {
  const { getInputProps, getLabelProps } = useCheckbox(useCheckboxProps);

  return (
    <IllustrationButton
      Illustration={Illustration}
      inputElement={
        <>
          <Flex justifyContent="center" alignItems="flex-end" flexShrink={0}>
            <Checkbox {...getLabelProps()} />
          </Flex>
          <Input {...getInputProps()} />
        </>
      }
      {...getLabelProps()}
      {...otherProps}
      dataTestId={dataTestId}
    >
      {children}
    </IllustrationButton>
  );
};

export default IllustrationCheckboxButton;
